/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetPaymentUrl200ResponseData } from './GetPaymentUrl200ResponseData'
import {
  GetPaymentUrl200ResponseDataFromJSON,
  GetPaymentUrl200ResponseDataFromJSONTyped,
  GetPaymentUrl200ResponseDataToJSON,
} from './GetPaymentUrl200ResponseData'

/**
 *
 * @export
 * @interface GetPaymentUrl200Response
 */
export interface GetPaymentUrl200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetPaymentUrl200Response
   */
  status: boolean
  /**
   *
   * @type {GetPaymentUrl200ResponseData}
   * @memberof GetPaymentUrl200Response
   */
  data: GetPaymentUrl200ResponseData
}

/**
 * Check if a given object implements the GetPaymentUrl200Response interface.
 */
export function instanceOfGetPaymentUrl200Response(
  value: object
): value is GetPaymentUrl200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetPaymentUrl200ResponseFromJSON(
  json: any
): GetPaymentUrl200Response {
  return GetPaymentUrl200ResponseFromJSONTyped(json, false)
}

export function GetPaymentUrl200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPaymentUrl200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetPaymentUrl200ResponseDataFromJSON(json['data']),
  }
}

export function GetPaymentUrl200ResponseToJSON(
  value?: GetPaymentUrl200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetPaymentUrl200ResponseDataToJSON(value['data']),
  }
}
